<template>
<nav>
    <input type="checkbox" id="check">
    <label for="check" class="checkbtn">
        <i class="fas fa-bars"></i>
    </label>
    <label>
        <a class="navbar-brand" href="#">
            <img src="../assets/images/code2.png" alt="Your Startup Logo" width="100" class="logo" />
        </a>
    </label>
    <ul>
        <li><a class="active" href="#">Home</a></li>
        <li class="nav-item">
            <a class="nav-link" href="https://www.codingkakeeda.in/">Blog</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="#about">About</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="#services">Services</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="#contact">Contact</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="https://certificate.codexearth.in/">Certificate verify</a>
        </li>
    </ul>
</nav>
</template>

  
<style scoped>
/* Your existing styles */

nav {
    background: #000000;
    height: 100px;
    width: 100%;
    display: flex;
    /* Use flexbox for better alignment */
    justify-content: space-between;
    /* Align items horizontally */
    align-items: center;
    /* Center items vertically */
    padding: 0 20px;
    /* Add some padding to the sides */
    position: fixed;
    top: 0px;
    z-index: 9999;
}

label.logo {
    color: white;
    font-size: 35px;
    font-weight: bold;
    margin: 0;
    /* Remove padding */
}

nav ul {
    list-style: none;
    /* Remove list bullets */
    margin: 0;
    padding: 0;
    display: flex;
    /* Use flexbox for the menu items */
}

nav ul li {
    margin: 0 10px;
    /* Add some spacing between menu items */
}

nav ul li a {
    color: rgb(255, 255, 255);
    font-size: 17px;
    text-transform: uppercase;
    text-decoration: none;
}

.checkbtn {
    font-size: 30px;
    color: white;
    cursor: pointer;
    display: none;
}

#check {
    display: none;
}

@media (max-width: 858px) {
    .checkbtn {
        display: block;
    }

    ul {
        position: fixed;
        width: 100%;
        height: 100vh;
        background: #2c3e50;
        top: 100px;
        left: -100%;
        text-align: center;
        transition: all .5s;
        margin: 0;
        /* Remove margin */
        padding: 0;
        /* Remove padding */
        flex-direction: column;
        /* Stack menu items vertically */
    }

    nav ul li {
        margin: 20px 0;
        /* Add spacing between stacked menu items */
    }

    nav ul li a {
        font-size: 20px;
    }

    a:hover,
    a.active {
        background: none;
        color: #0082e6;
    }

    #check:checked~ul {
        left: 0;
    }
}

ul li a:hover {
    color: red;
    text-decoration: none;
    /* Add bold font weight on hover */
}
</style>
